<template>
  <v-dialog
    v-model="dialog"
    :max-width="width"
    :style="{ zIndex: zIndex }"
    persistent
  >
    <v-card>
      <v-card-title class="py-0 pl-0 pr-2 mb-2">
        <v-chip class="ma-2" color="orange darken-3" outlined pill>
          <v-icon left> mdi-alert-octagram </v-icon>
          Hapus Gagal !
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn icon color="red" @click="agree">
          <v-icon>mdi-close-octagon-outline</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div>Mohon maaf !</div>
        <div>Anda tidak dapat menghapus data ini!</div>
        <div class="mt-1">Karena :</div>
        <div class="orange--text text--darken-3">
          {{ msg }}
        </div>
      </v-card-text>
      <v-card-actions class="mt-1">
        <v-spacer></v-spacer>
        <v-btn @click="agree" color="success" dark>Oke, Saya mengerti !</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      msg: null,
      zIndex: 400,
      width: 500,
    };
  },

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SET_SQL") {
        this.msg = state.sql;
        this.dialog = true;
      }
    });
  },

  methods: {
    agree() {
      this.dialog = false;
      this.msg = null;
      this.$store.commit("UNSET_SQL");
    },
  },
};
</script>

<style>
</style>